     var acc = document.getElementsByClassName("accordion");
     var i;

     for (i = 0; i < acc.length; i++) {
      if(i == 0 || i == 1 || i ==2 ){
        acc[i].classList.add("active");
        let panel = acc[i].nextElementSibling;
        if (panel.style.maxHeight) {
           panel.style.maxHeight = null;
        } else {
           panel.style.maxHeight = panel.scrollHeight + "px";
        } 
       }
     }

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
  });
}
     